import type {NextPage} from 'next'
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import React from 'react';
import LandingLayout from "../src/layouts/LandingLayout";
import DesktopHeroArea from "../src/components/desktopHeroArea/DesktopHeroArea";
import {useWindowSize} from "../src/utils/Hooks";
import MobileKayitForm from "../src/components/mobileKayitForm/MobileKayitForm";
import WaveLayout from "../src/layouts/WaweLayout";
import styled from "styled-components";
import {deviceMax} from "../styles/device";
import LandingSubHeroArea from "../src/components/landing/LandingSubHeroArea";
import LandingColumnComp from "../src/components/landing/LandingColumnComp";
import Image from "next/image";

import reklammarried from "/public/next/images/landing/reklam-married-min.webp";

const NedenPembePanjur: NextPage = () => {

    const windowSize = useWindowSize();

    const data = {
        LandingSubHeroAreaData: {
            breadcrumb: 'PEMBE PANJUR > NEDEN > NEDEN PEMBE PANJUR',
            saying: 'DOĞRU KİŞİYİ BULMAK ARTIK DAHA KOLAY!',
            propertyTopImg: '/next/assets/images/icons/icon-2.svg',
            propertyTopTitle: 'NEDEN PEMBE PANJUR?',
            propertyTopContent: "Pembe Panjur Türkiye'nin ilk ve tek karakter analizi ile bilimsel eşleştirme yapan \"Ciddi İlişki Sitesi\"dir. Pembe Panjur’da üyelik yaratma aşamasında üyelerin karakter analizi testine verdiği cevaplar doğrultusunda eşlestirme algoritması en uygun üyeleri seçerek eşlestirme yapar. Bu sistem sayesinde karakter analizi testini doğru ve eksiksiz olarak dolduran üye kendisine en uygun üyeler ile eşleşir.",
            propertyMiddleImg: '/next/assets/images/icons/icon-9.svg',
            propertyMiddleTitle: '2010 YILINDAN BÜGÜNE 10 MİLYON KAYITLI ÜYE',
            propertyMiddleContent: "Pembe Panjur 2010 yılından bugüne istikrarlı ve sürdürülebilir büyüme ile üye sayısını 10 milyonun üzerine çıkarmıştır. Pembe Panjur'un yarattığı güven iklimi kadın kullanıcılara da büyük rahatlık sağlamaktadır. Bu nedenle üyelerimizin üçte birinden fazlası kadınlardan oluşur. Üyeler arasındaki ortalama mesaj sayısı günlük 1.5 milyonun üzerindedir. Pembe Panjur olarak özelinizi ve gizliliğinizi korumak için özel önlemler almaktayız.Pembe Panjur’da yer alan profiller 7/24 Müşteri Hizmetleri tarafından sürekli kontrol edilmektedir. Kullanıcıların tüm bilgileri saklı tutulmakta ve kimse ile paylaşılmamaktadır.Üye profilleri hiçbir arama motorunda yer almaz. Pembe Panjur’da oluşturulan her üyelik gizlidir.",
            propertyBottomImg: '/next/assets/images/icons/icon-1.svg',
            propertyBottomTitle: 'PEMBE PANJUR HER YERDE YANINDA',
            propertyBottomContent: "Akıllı telefonunuza ücretsiz olarak indirebileceğiniz Pembe Panjur mobil uygulaması ile siz nereye giderseniz gidin aradığınız kişiyi bulma ihtimalini de yanınızda götüreceksiniz. Pembe Panjur mobil uygulaması sayesinde profil güncellemek ya da mesajlaşmak için artık bilgisayarınıza ihtiyacınız kalmadı. Ciddi evlilik sitesi, seviyeli bir arkadaşlık için Pembe Panjur uygulamasını şimdi telefonunuza indirin."
        }
    }

    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Pembe Panjur | Neden Pembe Panjur | Türkiye\'nin En Ciddi Arkadaşlık & Evlilik Sitesi'}
                description={'Pembe Panjur, ciddi ilişki arayanları bilimsel kişilik testi ve sosyo-ekonomik yaşam analizi ile eşleştiren tanışma sitesi olup, aynı zamanda flört ve evlilik sitesidir.'}
                canonical={true}
            />
            <style jsx global>{`
                body, body.amp-mode-touch {
                    font-family: 'Manrope', sans-serif;
                    background-color: rgba(0, 0, 0, 0.04);
                }

                .advertisement-content-container {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    box-sizing: border-box;
                    padding: 40px 24px 65px 24px;
                    background: rgba(0, 0, 0, 0.03);
                }

                .advertisement-content-container > .advertisement-content-wrapper {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    grid-gap: 100px;
                    padding: 0 calc(50vw - 575px);
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-img {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    padding: 0;
                    margin: 0 0 0 0;
                    box-sizing: border-box;
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-img img {
                    width: 100%;
                    height: 100%;
                    -o-object-fit: cover;
                    object-fit: cover;
                    border-radius: 12px;
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-text {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    padding: 0 0 0 0;
                    margin: 0 0 0 0;
                    box-sizing: border-box;
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-text p {
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 30px;
                    letter-spacing: 0;
                    color: #000000;
                    margin-bottom: 15px;
                }

                @media (max-width: 767px) {
                    .advertisement-content-container > .advertisement-content-wrapper {
                        grid-template-columns: 1fr;
                        grid-gap: 0;
                        padding: 0;
                    }
                }

            `}</style>
            {(windowSize.width < 768) ? (
                <WaveLayout backgroundColor={'unset'} hamburgerMenuType={'black'} hamburgerMenu={false}
                            loginButtonMenu={true} registerButton={false} waveComponent={false} bgColor={true}
                            extraChildren={
                                <React.Fragment>
                                    <LandingColumnComp imgAlt={'İstanbul Evlilik'}/>
                                    <div className={'advertisement-content-container'}>
                                        <div className={'advertisement-content-wrapper'}>
                                            <div className={'advertisement-content-img'}>
                                                <Image src={reklammarried}
                                                     alt={'Pembe Panjur, Mutlu Hayatların Başlangıcı'}/>
                                            </div>
                                            <div className={'advertisement-content-text'}>
                                                <p>
                                                    <span style={{fontWeight: 700}}>Gizlilik:</span>Pembe Panjur'da
                                                    üyerimizin profilleri tamamen gizlidir, sitede üyeler
                                                    arasında arama yapılamaz ayrıca üyelerin profilleri hiçbir arama
                                                    motorunda da
                                                    gözükmez. Sadece sitemizin bilimsel olarak eşleştirdiği üyelerin
                                                    birbirleriyle
                                                    görüşmesi mümkündür.
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 700}}>Bilimsel Eşleştirme:</span>Sistem
                                                    sizin
                                                    karakterinizi, kariyerinizi, eğitiminizi ve
                                                    daha bir çok faktörü değerlendirir, ve bu analiz sonucunda size
                                                    uygun üyeleri
                                                    tespit eder. Bu analizdeki esas hedef bir ömür boyu birbirleriyle
                                                    mutlu ve
                                                    huzurlu yaşayabilecek kişileri eşleştirebilmektir.
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 700}}>Ciddi İlişki:</span>Pembe Panjur,
                                                    birbirine
                                                    bilimsel olarak uygun üyeler arasında
                                                    ciddi, samimi ve dürüst bir ilişkinin başlamasına yardımcı olmayı
                                                    hedefler.
                                                    Sağladığımız hizmetin bütün basamakları bu ciddi ilişki hedefine
                                                    yönelik
                                                    tasarlanmıştır.
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 700}}>Güvenli:</span>Sitemize giriş
                                                    esnasında
                                                    bankalarca da kullanılan 256-bit SSL şifreleme
                                                    teknolojisi kullanılır. Ayrıca şifreleriniz de veritabanımızda
                                                    tekrar
                                                    şifrelenerek saklanır, dolayısıyla şifrelerin orjinallerinin
                                                    bilinmesi
                                                    imkansızdır.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                >
                    <React.Fragment>
                        <KayitWrapper>
                            <MobileKayitForm/>
                        </KayitWrapper>
                        <LandingSubHeroArea frontMatter={data.LandingSubHeroAreaData}/>
                    </React.Fragment>
                </WaveLayout>
            ) : (
                <LandingLayout
                    bodyBackgroundColor={false}
                    heroArea={
                        <React.Fragment>
                            <DesktopHeroArea advertisement={''}/>
                        </React.Fragment>
                    }
                    heroAreaBackgroundImage={'/next/assets/images/mobile-landing-hero-background.jpg'}
                    heroAreaBackgroundImageDesktop={'/next/images/landing/landing-reklam-hero-area-min.webp'}
                    subHeroArea={
                        <React.Fragment>
                            <LandingSubHeroArea frontMatter={data.LandingSubHeroAreaData}/>
                        </React.Fragment>
                    }
                >

                    <React.Fragment>
                        <LandingColumnComp imgAlt={'İstanbul Evlilik'}/>
                        <div className={'advertisement-content-container'}>
                            <div className={'advertisement-content-wrapper'}>
                                <div className={'advertisement-content-img'}>
                                    <Image src={reklammarried}
                                           alt={'Pembe Panjur, Mutlu Hayatların Başlangıcı'} />
                                </div>
                                <div className={'advertisement-content-text'}>
                                    <p>
                                        <span style={{fontWeight: 700}}>Gizlilik:</span>Pembe Panjur'da üyerimizin
                                        profilleri tamamen gizlidir, sitede üyeler
                                        arasında arama yapılamaz ayrıca üyelerin profilleri hiçbir arama motorunda da
                                        gözükmez. Sadece sitemizin bilimsel olarak eşleştirdiği üyelerin birbirleriyle
                                        görüşmesi mümkündür.
                                    </p>
                                    <p>
                                        <span style={{fontWeight: 700}}>Bilimsel Eşleştirme:</span>Sistem sizin
                                        karakterinizi, kariyerinizi, eğitiminizi ve
                                        daha bir çok faktörü değerlendirir, ve bu analiz sonucunda size uygun üyeleri
                                        tespit eder. Bu analizdeki esas hedef bir ömür boyu birbirleriyle mutlu ve
                                        huzurlu yaşayabilecek kişileri eşleştirebilmektir.
                                    </p>
                                    <p>
                                        <span style={{fontWeight: 700}}>Ciddi İlişki:</span>Pembe Panjur, birbirine
                                        bilimsel olarak uygun üyeler arasında
                                        ciddi, samimi ve dürüst bir ilişkinin başlamasına yardımcı olmayı hedefler.
                                        Sağladığımız hizmetin bütün basamakları bu ciddi ilişki hedefine yönelik
                                        tasarlanmıştır.
                                    </p>
                                    <p>
                                        <span style={{fontWeight: 700}}>Güvenli:</span>Sitemize giriş esnasında
                                        bankalarca da kullanılan 256-bit SSL şifreleme
                                        teknolojisi kullanılır. Ayrıca şifreleriniz de veritabanımızda tekrar
                                        şifrelenerek saklanır, dolayısıyla şifrelerin orjinallerinin bilinmesi
                                        imkansızdır.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                </LandingLayout>
            )}


        </React.Fragment>
    )
}


const KayitWrapper = styled.div`
    position: relative;
    background: #0000000D;
    width: calc(100% + 70px);
    margin-left: -35px;

    @media ${deviceMax.tablet} {
        padding: 0 35px 20px;
        margin-bottom: 20px;
    }
`;


export default NedenPembePanjur;
